import React, { useEffect, useState } from 'react';
import api from '@api';
import { NavLink, useNavigate } from 'react-router-dom';
import './SchedulePublic.css';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { useDomain } from '@useDomain';


function SchedulePublic() {
  const [games, setGames] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [selectedLeague, setSelectedLeague] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(true);
  const { slug, domain } = useDomain(); // inside SchedulePublic
  const [selectedTeam, setSelectedTeam] = useState("");
  const leagueOrder = [
    "Fountain Valley",
    "Tustin Columbus",
    "Irvine Valley College"
  ];
  const dayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [gameStatusFilter, setGameStatusFilter] = useState("all");
  const [byes, setByes] = useState([]);
  const [weekOffs, setWeekOffs] = useState([]); // ✅ ADD THIS


  const navigate = useNavigate()
  useEffect(() => {
    if (!slug && !domain) {
      console.warn("No slug or domain, skipping fetch");
      return;
    }

    const fetchGames = async () => {
      try {
        const res = await api.get(`/api/gamesv2`, { params: slug ? { slug } : { domain } });

        setGames(res.data.games);
      } catch (error) {
        console.log("Error fetching games:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchLeagues = async () => {
      try {
        const res = await api.get(`/api/leaguesv2`, { params: slug ? { slug } : { domain } });

        setLeagues(res.data.leagues);
      } catch (error) {
        console.log("Error fetching leagues:", error);
      }
    };
    const fetchByes = async () => {
      try {
        const res = await api.get(`/api/bye-dates/public`, { params: slug ? { slug } : { domain } });
        setByes(res.data.byes || []);
      } catch (err) {
        console.error("Error fetching byes:", err);
      }
    };

    const fetchWeekOffs = async () => {
      try {
        const res = await api.get(`/api/week-offs/public`, { params: slug ? { slug } : { domain } });
        setWeekOffs(res.data || []);
      } catch (err) {
        console.error("Error fetching week-offs:", err);
      }
    };
    fetchWeekOffs();

    fetchGames();
    fetchLeagues();
    fetchByes();

  }, [domain, slug]);

  console.log(leagues)
  const activeGames = games.filter(game => game.season_id); // Or any extra season checks if needed


  let gamesForFilters = activeGames;

  if (selectedDate) {
    gamesForFilters = gamesForFilters.filter(game =>
      game.date?.slice(0, 10) === selectedDate
    );
  }

  if (selectedLeague) {
    gamesForFilters = gamesForFilters.filter(game =>
      game.leagueId === Number(selectedLeague)
    );
  }

  if (selectedTeam) {
    gamesForFilters = gamesForFilters.filter(game =>
      game.homeTeam?.id === Number(selectedTeam) || game.awayTeam?.id === Number(selectedTeam)
    );
  }


  // Unique League Options
  const uniqueDates = [...new Set(
    activeGames.map(game => game.date?.slice(0, 10))
  )].sort();


  const activeLeagueIds = [...new Set(activeGames.map(g => g.leagueId).filter(Boolean))];

  const uniqueLeagues = leagues
    .filter(l => activeLeagueIds.includes(l.id) && l.seasons_leagues?.length > 0)
    .map(l => ({
      id: l.id,
      name: l.name,
      seasons_leagues_id: l.seasons_leagues[0].id
    }))
    .sort((a, b) => {
      const locationIndexA = leagueOrder.findIndex(loc => a.name.includes(loc));
      const locationIndexB = leagueOrder.findIndex(loc => b.name.includes(loc));

      if (locationIndexA !== locationIndexB) {
        if (locationIndexA === -1) return 1;
        if (locationIndexB === -1) return -1;
        return locationIndexA - locationIndexB;
      }

      const dayA = dayOrder.find(day => a.name.includes(day)) || "";
      const dayB = dayOrder.find(day => b.name.includes(day)) || "";
      const dayIndexA = dayOrder.indexOf(dayA);
      const dayIndexB = dayOrder.indexOf(dayB);

      if (dayIndexA === -1 && dayIndexB === -1) return a.name.localeCompare(b.name);
      if (dayIndexA === -1) return 1;
      if (dayIndexB === -1) return -1;
      return dayIndexA - dayIndexB;
    });



  const allGameTeams = activeGames.flatMap(game =>
    [game.homeTeam, game.awayTeam].filter(Boolean)
  );

  const allTeams = [
    ...allGameTeams,
    ...byes.flatMap(bye => bye.teams)
  ];


  const uniqueTeams = [
    ...new Map(allTeams.map(team => [team.id, team])).values()
  ].sort((a, b) => a.name.localeCompare(b.name));


  let filteredGames = gamesForFilters;

  if (gameStatusFilter === "completed") {
    filteredGames = filteredGames.filter(
      (game) => Number(game.score_team1) > 0 || Number(game.score_team2) > 0
    );
  } else if (gameStatusFilter === "scheduled") {
    filteredGames = filteredGames.filter(
      (game) => !game.score_team1 && !game.score_team2
    );
  }

  const filteredByes = byes.filter(bye => {
    const matchesDate = !selectedDate || bye.date?.slice(0, 10) === selectedDate;
    const matchesTeam = !selectedTeam || bye.teams.some(t => t.id === Number(selectedTeam));
    const matchesLeague = !selectedLeague || bye.league_id === Number(selectedLeague);

    return matchesDate && matchesTeam && matchesLeague;
  });


  const selectedSeasonsLeaguesId = uniqueLeagues.find(l => l.id === Number(selectedLeague))?.seasons_leagues_id;

  const filteredWeekOffs = weekOffs.filter(off => {
    const matchesDate = !selectedDate || off.date?.slice(0, 10) === selectedDate;
    const matchesLeague = !selectedLeague || off.seasons_leagues_id === selectedSeasonsLeaguesId;
    return matchesDate && matchesLeague;
  });


  console.log(filteredWeekOffs)


  const weekOffEntries = filteredWeekOffs.map((off, index) => ({
    id: `weekoff-${index}`,
    date: off.date,
    reason: off.reason,
    type: 'week_off',
  }));

  const byeEntries = filteredByes.map((bye, index) => ({
    id: `bye-${index}`,
    date: bye.date,
    teams: bye.teams.map(t => ({ id: t.id, name: t.name })),
    type: 'bye',
  }));



  const displayRows = [...filteredGames, ...byeEntries, ...weekOffEntries].sort((a, b) => {
    const dateA = new Date(`${a.date}T${a.time || '00:00'}`);
    const dateB = new Date(`${b.date}T${b.time || '00:00'}`);
    return dateA - dateB;
  });

  if (loading) return null;

  return (
    <div className="schedulePublic-container">
      <div className='schedulePublic-league-name-container'>
        <h2 className="schedulePublic-league-title">
          <div className="date-filter-wrapper">

            <select value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}>
              <option value="">All Dates</option>
              {uniqueDates.map(date => (
                <option key={date} value={date}>
                  {formatInTimeZone(`${date}T12:00:00`, 'America/Los_Angeles', 'MMMM d, yyyy')}
                </option>
              ))}
            </select>

            <select value={selectedLeague} onChange={(e) => setSelectedLeague(e.target.value)}>
              <option value="">All Leagues</option>
              {uniqueLeagues.map(l => (
                <option key={l.id} value={l.id}>{l.name}</option>
              ))}
            </select>



            <select value={selectedTeam} onChange={(e) => setSelectedTeam(e.target.value)}>
              <option value="">All Teams</option>
              {uniqueTeams.map(team => (
                <option key={team.id} value={team.id}>{team.name}</option>
              ))}
            </select>
            <select value={gameStatusFilter} onChange={(e) => setGameStatusFilter(e.target.value)}>
              <option value="all">All Games</option>
              <option value="scheduled">Scheduled Games</option>
              <option value="completed">Completed Games</option>
            </select>

          </div>
        </h2>
      </div>

      {displayRows.length > 0 ? (
        <div className="schedulePublic-game-container">
          <table className="schedulePublic-game-container-table">
            <thead>
              <tr className="schedule-head-font">
                <th>Date</th>
                <th>Matchup</th>
                <th>Time</th>
                <th>Results</th>
              </tr>
            </thead>
            <tbody>
              {displayRows.map((entry) => {
                if (entry.type === 'week_off') {
                  return (
                    <tr key={entry.id} className="week-off-row">
                      <td>
                        {formatInTimeZone(new Date(`${entry.date}T12:00:00`), 'America/Los_Angeles', 'MMMM d, yyyy')}
                      </td>
                      <td colSpan={3}>🛑 No Games ({entry.reason || 'Off Week'})</td>
                    </tr>
                  );
                }
                if (entry.type === 'bye') {
                  return (
                    <tr key={entry.id} className="bye-row">
                      <td>
                        {formatInTimeZone(new Date(`${entry.date}T12:00:00`), 'America/Los_Angeles', 'MMMM d, yyyy')}
                      </td>
                      <td>
                        {entry.teams.map(t => t.name).join(', ')} (BYE)
                      </td>
                      <td>BYE</td>
                      <td>BYE</td>
                    </tr>
                  );
                }

                const homeTeam = entry.homeTeam?.id === entry.team1_id ? entry.homeTeam : entry.homeTeam;
                const awayTeam = entry.awayTeam?.id === entry.team2_id ? entry.awayTeam : entry.awayTeam;
                const homeScore = entry.score_team1;
                const awayScore = entry.score_team2;

                return (
                  <tr
                    key={entry.id}
                    onClick={() => navigate(slug ? `/${slug}/games/${entry.id}` : `/games/${entry.id}`)}
                    style={{ cursor: 'pointer' }}
                    className="clickable-row"
                  >
                    <td>
                      {entry.date ? formatInTimeZone(new Date(`${entry.date}T12:00:00`), 'America/Los_Angeles', 'MMMM d, yyyy') : 'TBD'}
                    </td>
                    <td>{homeTeam?.name} vs {awayTeam?.name}</td>
                    <td>
                      {entry.time && /^\d{2}:\d{2}$/.test(entry.time)
                        ? format(new Date(`${entry.date}T${entry.time}`), 'h:mm a')
                        : 'TBD'}
                    </td>
                    <td>{homeScore} - {awayScore}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No games, byes, or week-offs found.</p>
      )}


    </div>
  );
}

export default SchedulePublic;
